import { render } from "./ListeMarchandPage.vue?vue&type=template&id=6b940d8c&ts=true"
import script from "./ListeMarchandPage.vue?vue&type=script&lang=ts"
export * from "./ListeMarchandPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__